import React from "react";
import PropTypes from "prop-types";
import {baseFields as baseColumnFields, editFields as editColumnFields, contentFields as contentColumnFields} from "./columns";
import { getFields } from './formUtils'
import { component_tool } from "@/tool";
import moment from 'moment'
const { WizCard, WizAntdForm, WizRow, WizButton } = component_tool;

class ContentForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      baseFields: baseColumnFields(props.record, this.props.hiddenType),
      editFields: editColumnFields(props.record, this.props.hiddenType),
      contentFields: contentColumnFields(props.record, this.props.hiddenType),
      record: props.record
    };
  }

  componentWillMount() {
    //格式化各个字段
    if(JSON.stringify(this.state.record)==='{}') return
    const record = JSON.parse(JSON.stringify(this.state.record))
    record.releaseTime = moment(record.releaseTime, 'YYYY-MM-DD HH:mm:ss')
    record.fileImgObj = [{ fileId:record.img }]
    record.categoryArr = record.categoryIds.map(val => { return { key: val.id, title: val.name } })
    const baseFields = baseColumnFields(record, this.props.hiddenType);
    const editFields = editColumnFields(record, this.props.hiddenType);
    const contentFields = contentColumnFields(record, this.props.hiddenType);
    this.setState({ record, baseFields, editFields, contentFields })
  }


  onChangeRowMap = rows => {
    // const { record } = this.state
    // const labelIds = Object.values(rows).map(val => { return { id: val.id, name: val.title || val.name } })
    // const result = { ...record, labelIds, title: '1221' }
    // const fields = columns(result)
    // console.log('result',result);
    // this.setState({ record: result, fields, key: new Date().getTime() })
  }

  // 表单提交
  handleSubmit = (releaseState) => {
    // e.preventDefault();
    const { form, onSubmit } = this.props;
    form.validateFields((err, values) => {
      if (!err) {
        onSubmit && onSubmit([undefined, null].indexOf(releaseState) !== -1 ? values : {...values, releaseState: releaseState});
      }else{
        window.scrollTo(0,0)
      }
    });
  };

  footer = () => {
    let {hiddenType, isupdate = false} = this.props
    let btns = []
    if (hiddenType === 'learningMaterials') {
      if(!isupdate) {
        btns.push(<WizButton title="保存为草稿" type="primary" onClick={() => this.handleSubmit(0)}>保存为草稿</WizButton>)
        btns.push(<div style={{width: 60}}></div>)
      }
      btns.push(<WizButton title="保存并发布" type="primary" onClick={() => this.handleSubmit(1)}>保存并发布</WizButton>)
    } else {
      btns.push(<WizButton title="提交" type="primary" onClick={() => this.handleSubmit()}>提交</WizButton>)
    }

    return  (
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        {btns}
      </div>
    )
  }

  render() {
    const { hiddenType, form } = this.props;
    const { baseFields, editFields, contentFields } = this.state

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
    };
    const other = { form, formItemLayout, onChangeRowMap: this.onChangeRowMap }
    return (
      <WizAntdForm {...formItemLayout} key={this.state.key}>
        <WizCard title="基础信息">
          {getFields({fields: baseFields, ...other  }, hiddenType)}
          <WizRow>{getFields({fields: editFields, withCol: true, colSpan: 12, ...other  })}</WizRow>
        </WizCard>
        <WizCard title="详细内容">
          {getFields({fields: contentFields, ...other  })}
          {this.footer()}
        </WizCard>
      </WizAntdForm>
    );
  }
}

export default WizAntdForm.create({})(ContentForm);

/**
 * 默认值
 */
ContentForm.defaultProps = {
  contentType: 1, // 类容类型{1：文章, 2:图片 ...}
  hiddenType: 'content',
  record: {}
};

/**
 * props入参校验
 */
ContentForm.propTypes = {
  contentType: PropTypes.number,
  record: PropTypes.object,
  hiddenType: PropTypes.oneOf(['content', 'learningMaterials'])
};
